import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  fetchListLicenses,
  fetchListLicensesLogs,
  ILicenseItem,
  ListLicenses,
  ListLicensesLogs,
} from 'api/productApi'
import {RootState} from 'store'

export const handleGetListLicenseWithItem = createAsyncThunk(
  'productUsage/getListLicenseWithItem',
  async (_, {rejectWithValue}) => {
    try {
      const response = await fetchListLicenses()
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const handleGetListLicenseLogs = createAsyncThunk(
  'productUsage/getListLicenseLogs',
  async (payload: string, {rejectWithValue}) => {
    try {
      const response = await fetchListLicensesLogs(payload)
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

interface OrgCanRegisterState {
  loading: boolean
  error: unknown
  // query: OrgCanRegisterParam
  selectedLicense: ILicenseItem | null
  listLicenseWithItem: ListLicenses[] | []
  listActive: ListLicenses[] | []
  listDiscontinued: ListLicenses[] | []
  listLicenseLogs: ListLicensesLogs | null
  // totalPages: number
}

const initialState: OrgCanRegisterState = {
  loading: false,
  error: undefined,
  selectedLicense: null,
  listLicenseWithItem: [],
  listActive: [],
  listDiscontinued: [],
  listLicenseLogs: null,
}

export const productUsageHistorySlice = createSlice({
  name: 'productUsageHistory',
  initialState,
  reducers: {
    setSelectLicense: (state, action: PayloadAction<ILicenseItem>) => {
      state.selectedLicense = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleGetListLicenseWithItem.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListLicenseWithItem.fulfilled, (state, action) => {
        state.loading = false
        state.listLicenseWithItem = action.payload.data
        state.listActive = action.payload.data.filter(
          (item) =>
            item.status === 'ACTIVE' &&
            item.deactivationDateTime > new Date().getTime(),
        )
        state.listDiscontinued = action.payload.data.filter(
          (item) =>
            item.status !== 'ACTIVE' ||
            item.deactivationDateTime <= new Date().getTime(),
        )
      })
      .addCase(handleGetListLicenseWithItem.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

    builder
      .addCase(handleGetListLicenseLogs.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListLicenseLogs.fulfilled, (state, action) => {
        state.loading = false
        state.listLicenseLogs = action.payload.data
      })
      .addCase(handleGetListLicenseLogs.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const {setSelectLicense} = productUsageHistorySlice.actions

export default productUsageHistorySlice.reducer

export const selectLoading = (state: RootState) =>
  state.productUsageHistory.loading
export const selectedLicenseData = (state: RootState) =>
  state.productUsageHistory.selectedLicense
export const selectError = (state: RootState) => state.productUsageHistory.error

export const selectListLicenseWithItem = (state: RootState) =>
  state.productUsageHistory.listLicenseWithItem
export const selectListLicenseLogs = (state: RootState) =>
  state.productUsageHistory.listLicenseLogs

export const selectListActive = (state: RootState) =>
  state.productUsageHistory.listActive
export const selectListDiscontinue = (state: RootState) =>
  state.productUsageHistory.listDiscontinued
